import { ref } from '@vue/composition-api'
import draftApi from '@/services/api/drafts'

export default function useMyDraftsSummary() {
  const items = ref([])
  const loading = ref(false)

  async function fetch() {
    loading.value = true
    try {
      const res = await draftApi.myNominationsSummary()
      items.value = res.data.data != null ? res.data.data : []
    } catch (_err) {
      // ошибки обрабатываются глобально через http.js interceptor
    } finally {
      loading.value = false
    }
  }

  return { items, loading, fetch }
}



// WEBPACK FOOTER //
// ./src/composables/nominations/useMyDraftsSummary.js